module.exports = __webpack_public_path__ + "NovyBor-sadova.jpg?f5675469b32594402260868c48388eb5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/NovyBor-sadova.jpg
// module id = 232
// module chunks = 0